module.exports = __webpack_public_path__ + "img/form_bank_img.webp";